(function() {
  'use strict';
  
  angular
    .module('plugins.free-text-response')
    .controller('FreeTextResponseResultHiddenController', FreeTextResponseResultHiddenController);
  
    FreeTextResponseResultHiddenController.$inject = [
    '$log', 
    '$scope',
    'pollPluginService'
  ];
    
  function FreeTextResponseResultHiddenController(
      $log, 
      $scope,
      pollPluginService
    ) {
    $log = $log.getInstance('FreeTextResponseResultHiddenController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.numberOfResponses = 0

    activate();

    function activate() {
      var result = $scope.result;
      
      // Run through previous responses
      result.responses.forEach(function(response) { 
        if (response.data.textResponse) vm.numberOfResponses++
      })

      pollPluginService.onResponseReceived($scope, result._id, _onResponseReceived);
    }
    
    function _onResponseReceived(response) {
      $scope.result.responses.push(response)
      if (response.data.textResponse) vm.numberOfResponses++
    }
    
  }
  
})();